<div
    class="avatar"
    [ngClass]="shapee()"
    [ngStyle]="{
    width: sizePx(),
    height: sizePx(),
    'background-color': colorBackground()
    }"
>
    @if (image()) {
        <img
            [src]="image()"
            alt="avatar"
        />
    }@else {
        <span class="placeholder" [ngStyle]="{'font-size': sizeFont() }"  >{{ initialName() }}</span>
    }
</div>
